import { styled } from "@mui/material/styles";
import { Grid, Avatar, Divider, Link, Typography } from "@mui/material";

export const StyledDivBoxWrapper = styled(Grid)(({ theme }) => ({
  padding: "20px",
  backgroundColor: theme.palette.background.paper,
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  display: "flex",
  gap: theme.spacing(1),
}));

export const StyledTopBar = styled("div")<{ color?: string }>(({ theme, color }) => ({
  textAlign: "center",
  height: "10px",
  backgroundColor: color || theme.palette.primary.main,
  width: "100%",
}));

export const StyledAvatar = styled(Avatar)(() => ({
  width: "80px",
  height: "80px",
}));

export const StyledInfoBox = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

export const StyledContactContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "left",
  gap: "5px",
  width: "100%",
}));

export const StyledContactRow = styled("div")(() => ({
  display: "flex",
  gap: "10px",
  marginLeft: "20px",
}));

export const StyledLinkContainer = styled("div")(() => ({
  textAlign: "left",
  width: "100%",
}));

export const StyledDetailsScroll = styled("div")(({ theme }) => ({
  maxHeight: "40vh",
  overflowY: "auto",
  paddingRight: theme.spacing(1),
  "&::-webkit-scrollbar": {
    display: "none",
  },
}));

export const StyledDivider = styled(Divider)(() => ({
  width: "100%",
}));

export const StyledGridRow = styled(Grid)(() => ({
  width: "100%",
}));

export const StyledTypography = styled(Typography)(() => ({}));

export const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: "none",
  cursor: "pointer",
  marginTop: theme.spacing(1),
}));
